var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome sides-padding"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"welcome-inner"},[_c('h1',{staticClass:"welcome-title"},[_vm._v("Добро пожаловать на Baby Market!")]),_c('span',{staticClass:"welcome-subtitle"},[_vm._v("\n        Baby Market – это концептуальный и сказочный мир для детей и будущих родителей.\n      ")])])])])
}]

export { render, staticRenderFns }